export default __webpack_public_path__ + "static/media/options_button_icon.4598d9a1.svg";